import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'react-apollo';
import { getTopicQuestionsFilter } from 'legacy-packages/unit-outline/src/components/_shared/util';
import TopicQuestionPreview from 'chameleon-packages/units/components/TopicQuestionPreview';
import withCourseOutline from 'chameleon-packages/units/composable/withCourseOutline';
import { constants } from 'chameleon/ui-stack/ui/units/utils';

const TopicQuestionPreviewWrapper = (props) => {
  const {
    courseOutline: {
      widgetTagColumn,
      unitsLabel,
      units = [],
      subunitLabel,
    } = {},
    router,
    params,
    location: { query },
    blueBookUiFlag,
  } = props;
  const { previewId, subject } = params;
  const { unit: unitNumber, subunit: subunitNumber } = query;

  const getSubunitData = useMemo(() => {
    if (units.length < 1) {
      return [];
    }

    const unit = units.find(({ number }) => number === unitNumber) || {};
    const { title: unitTitle, subunits } = unit;
    const subunit =
      subunits.find(({ number }) => number === subunitNumber) || {};
    const { metadata, resources: subunitResources = [] } = subunit;
    const { ResourceTypes } = constants;
    const topicQuestionRawResource =
      subunitResources.find(
        ({ __typename }) => __typename === ResourceTypes.PRACTICE_QUESTIONS,
      ) || {};

    const topicQuestionsFilter = getTopicQuestionsFilter({
      subjectId: subject,
      unitNumber,
      metadata,
      widgetTagColumn,
      skipCustomFilters: false,
      unitTitle,
      unitsLabel,
      subunitLabel,
    });

    const { questions } = topicQuestionRawResource;
    const itemIds = questions.map(({ itemId }) => itemId.toString());

    return {
      topicQuestionsFilter,
      items: questions,
      itemIds,
    };
  }, [unitNumber, subunitNumber, units]);

  const { topicQuestionsFilter, items = [], itemIds = [] } = getSubunitData;

  const onCreateQuiz = ({ title }) => {
    router.push({
      pathname: `/${subject}/question_bank/create/auto-build/filters`,
      state: {
        topicQuestionsFilter,
        quizTitle: title,
        quizItems: itemIds,
      },
    });
  };

  const showPreviewItem =
    previewId && itemIds.find((itemId) => itemId === previewId);

  if (!showPreviewItem) {
    return null;
  }

  return (
    <TopicQuestionPreview
      blueBookUiFlag={blueBookUiFlag}
      previewId={previewId}
      items={items.map((item) => ({ ...item, is_topic_question: true }))}
      itemIds={itemIds}
      router={router}
      params={params}
      onCreateQuiz={onCreateQuiz}
    />
  );
};

TopicQuestionPreviewWrapper.propTypes = {
  userData: PropTypes.object,
  blueBookUiFlag: PropTypes.bool,
};

TopicQuestionPreviewWrapper.defaultProps = {
  userData: {},
  blueBookUiFlag: false,
};

export default compose(
  withRouter,
  withCourseOutline(),
)(TopicQuestionPreviewWrapper);
